import React from "react";
import { NavLink, useNavigate, Outlet } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Gem, LayoutDashboard, Users, Megaphone, Target, Settings, LogOut, Search } from "lucide-react";

const navItems = [
  { to: "/dashboard", icon: LayoutDashboard, label: "Overview", testid: "nav-overview" },
  { to: "/dashboard/leads", icon: Users, label: "Leads", testid: "nav-leads" },
  { to: "/dashboard/campaigns", icon: Megaphone, label: "Campaigns", testid: "nav-campaigns" },
  { to: "/dashboard/icp", icon: Target, label: "ICP", testid: "nav-icp" },
  { to: "/dashboard/settings", icon: Settings, label: "Settings", testid: "nav-settings" },
];

export default function DashboardLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <div className="min-h-screen flex">
      {/* Sidebar */}
      <aside className="w-64 border-r border-white/5 bg-black/40 backdrop-blur-xl flex flex-col p-4 sticky top-0 h-screen" data-testid="dashboard-sidebar">
        <div className="flex items-center gap-2.5 px-2 py-3 mb-6">
          <Gem className="w-6 h-6 text-gold" />
          <span className="font-display text-lg font-semibold text-white">My Leads Convert</span>
        </div>

        <nav className="space-y-1 flex-1">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/dashboard"}
              data-testid={item.testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                  isActive ? "text-gold bg-yellow-300/10 font-medium" : "text-zinc-400 hover:text-white hover:bg-white/5"
                }`
              }
            >
              <item.icon className="w-4 h-4" />
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="border-t border-white/5 pt-4 mt-4">
          <div className="px-3 py-2 mb-2">
            <div className="text-sm text-white font-medium truncate">{user?.name || "User"}</div>
            <div className="text-xs text-zinc-500 truncate">{user?.email}</div>
          </div>
          <button
            onClick={async () => { await logout(); nav("/"); }}
            className="w-full flex items-center gap-3 px-3 py-2 rounded-lg text-sm text-zinc-400 hover:text-rose-300 hover:bg-rose-500/5 transition-colors"
            data-testid="dashboard-logout"
          >
            <LogOut className="w-4 h-4" />
            Log out
          </button>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 min-w-0">
        <Outlet />
      </main>
    </div>
  );
}
